module.exports = __webpack_public_path__ + "static/media/form-placeholder.9a6dca83.svg";